import styled from "styled-components";
import {HeaderNavbarMobileBaseBox} from "../../../boxes/header-navbar-mobile-base/header-navbar-mobile-base.box";
import {HEADER_Z_INDEX} from "../../../header-consts";

export const RegulatoryDataDefaultBox = styled(HeaderNavbarMobileBaseBox)`
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: ${HEADER_Z_INDEX + 1};
    
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    flex-direction: column;
    width: 100%;
    padding: calc(env(safe-area-inset-top) + 0.5rem) 1.5rem 0.5rem 1.5rem;
  }

  .cgp-dk & {
    flex-direction: row-reverse;
  }

`;